<template>
  <div id="Signup">
    <div class="row xv_signup_wrap">
      <div class="col-5 left_sec">
        <div class="cover">
          <img src="../../../assets/signup.jpg" alt />
        </div>
        <div class="main_title">
          <span>
            Get Started
            <br />with XV
          </span>
        </div>
        <div class="sub_title">
          <span>Sign up for a demo account and explore the platform yourself.</span>
        </div>
        <div class="show_case">
          <div>
            <span class="mdi mdi-check-bold"></span> Free 14-day demo
          </div>
          <div>
            <span class="mdi mdi-check-bold"></span> No credit card needed
          </div>
          <div>
            <span class="mdi mdi-check-bold"></span> No setup
          </div>
        </div>
      </div>
      <div class="col-7 right_sec">
        <div class="step_1" v-if="step_count == '1'">
          <div class="step_count">
            <div class="count">
              <span>1/3</span>
            </div>
            <div>
              <button class="modal_close" @click="close_signup()">
                <span class="mdi mdi-close"></span>
              </button>
            </div>
          </div>
          <div class="step_title">
            <span>How many employees do you have?</span>
          </div>
          <div class="step_content">
            <div class="employee_count" @click="step_change(2)">
              <div class="e_count">1-5</div>
              <div>
                <span class="mdi mdi-arrow-right"></span>
              </div>
            </div>
            <div class="employee_count" @click="step_change(2)">
              <div class="e_count">6-10</div>
              <div>
                <span class="mdi mdi-arrow-right"></span>
              </div>
            </div>
            <div class="employee_count" @click="step_change(2)">
              <div class="e_count">11-25</div>
              <div>
                <span class="mdi mdi-arrow-right"></span>
              </div>
            </div>
            <div class="employee_count" @click="step_change(2)">
              <div class="e_count">26-150</div>
              <div>
                <span class="mdi mdi-arrow-right"></span>
              </div>
            </div>
            <div class="employee_count" @click="step_change(2)">
              <div class="e_count">150+</div>
              <div>
                <span class="mdi mdi-arrow-right"></span>
              </div>
            </div>
          </div>
        </div>
        <div class="step_2" v-if="step_count == '2'">
          <div class="step_count">
            <div class="count">
              <span>2/3</span>
            </div>
            <div>
              <button class="modal_close" @click="close_signup()">
                <span class="mdi mdi-close"></span>
              </button>
            </div>
          </div>
          <div class="step_title">
            <span>Tell us a little about yourself.</span>
          </div>
          <div class="step_content">
            <div class="signup_form row">
              <div class="col-12">
                <div class="input_wrap">
                  <span class="mdi mdi-email"></span>
                  <input type="text" placeholder="Work Email" />
                </div>
              </div>
              <div class="col-6">
                <div class="input_wrap">
                  <span class="mdi mdi-shield-key"></span>
                  <input type="password" placeholder="Create password" />
                </div>
              </div>
              <div class="col-6">
                <div class="input_wrap">
                  <span class="mdi mdi-shield-key"></span>
                  <input type="password" placeholder="Confirm password" />
                </div>
              </div>
              <div class="col-6">
                <div class="input_wrap">
                  <span class="mdi mdi-account"></span>
                  <input type="text" placeholder="First Name" />
                </div>
              </div>
              <div class="col-6">
                <div class="input_wrap">
                  <span class="mdi mdi-account"></span>
                  <input type="text" placeholder="Last Name" />
                </div>
              </div>
              <div class="col-12">
                <div class="input_wrap">
                  <span class="mdi mdi-office-building"></span>
                  <input type="text" placeholder="Company" />
                </div>
              </div>
              <div class="col-12">
                <div class="input_wrap">
                  <span class="mdi mdi-phone"></span>
                  <input type="text" placeholder="Work Phone" />
                </div>
              </div>
            </div>
            <div class="step_footer">
              <button class="back" @click="step_change(1)">
                <span class="mdi mdi-arrow-left"></span> BACK
              </button>
              <button class="next" @click="step_change(3)">Next</button>
            </div>
          </div>
        </div>

        <div class="step_3" v-if="step_count == '3'">
          <div class="step_count">
            <div class="count">
              <span>3/3</span>
            </div>
            <div>
              <button class="modal_close" @click="close_signup()">
                <span class="mdi mdi-close"></span>
              </button>
            </div>
          </div>
          <div class="step_title">
            <span>Verification code</span>
          </div>
          <div class="step_content">
            <div class="otp_content">
              <label>
                Please enter the verification code sent to
                +1-20*-***-**35
              </label>
              <input type="text" />
            </div>
            <div class="step_footer last">
              <button class="back" @click="step_change(2)">
                <span class="mdi mdi-arrow-left"></span> BACK
              </button>
              <button class="next" @click="signup()">GET STARTED</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import employeePolicies from "./employee_policies/employee_policies.vue"

export default {
  name: "Signup",
  components: {
    // employeePolicies,visitorPolicies,healthDeclarations,securityPartners,company,account
  },
  data() {
    return {
      step_count: 1
    };
  },
  methods: {
    signup: function() {
      this.$router.push("/xv-admin/dashboard");
    },
    step_change: function(step) {
      this.step_count = step;
    },
    close_signup: function() {
      this.$modal.hide("signup");
    }
  }
};
</script>
